// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar[data-v-6e96ec38]{background-color:#fff;cursor:pointer}.openedSidebar[data-v-6e96ec38]{cursor:unset}.navigation[data-v-6e96ec38]{padding:20px;width:70px;transition:width .15s ease-out;display:flex;flex-direction:column}.opened[data-v-6e96ec38]{width:240px}", ""]);
// Exports
module.exports = exports;
